module.exports = __webpack_public_path__ + "img/default-member.2d73baf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/default-member.png
// module id = rA+B
// module chunks = 1